function normalizeNamePart(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function formatLeadDisplayName(args: {
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
}): string {
  const firstName = normalizeNamePart(args.firstName);
  const lastName = normalizeNamePart(args.lastName);

  if (firstName !== null && lastName !== null) {
    return `${firstName} ${lastName}`;
  }

  if (firstName !== null) {
    return firstName;
  }

  if (lastName !== null) {
    return lastName;
  }

  return normalizeNamePart(args.fullName) ?? '';
}
